import { Component, EventEmitter, Inject, OnInit, ViewChild } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_814';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Valor de la sanción  ', listHelp: ['812'] },
  { text: "2", active: true, completed: false, tooltip: 'Valor Gradualidad ', listHelp: ['813'] }
];
class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-descuentos-sancion-extemporanea-modal',
  templateUrl: './descuentos-sancion-extemporanea-modal.component.html',
  styleUrls: ['./descuentos-sancion-extemporanea-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class DescuentosSancionExtemporaneaModalComponent extends HandlerModal implements OnInit {

  public lstGradualidad: ArticulosDominio[] = [];
  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;
  constructor(
    public dialogRef: MatDialogRef<DescuentosSancionExtemporaneaModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
    this.initializeGradualidad();
  }

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_812 == undefined)this.model.doc.cuerpo.cs_id_812 = "0";
    if(this.model.doc.cuerpo.cs_id_813 == undefined)this.model.doc.cuerpo.cs_id_813 = null;
    if(this.model.doc.cuerpo.cs_id_814 == undefined)this.model.doc.cuerpo.cs_id_814 = "0";
    
  }
  protected initializeGradualidad(){
    this.lstGradualidad[0] = {valor:0,nombre:""};
    this.lstGradualidad[1] = {valor:1,nombre:"Primera declaración extemporánea."};
    this.lstGradualidad[2] = {valor:2,nombre:"Dos años anteriores"};
    this.lstGradualidad[3] = {valor:3,nombre:"Año anterior"};
    this.lstGradualidad[4] = {valor:4,nombre:"No aplica."};
  }
  
  public operaciones(numCas?: number, soloEstaCasilla?: boolean): void {
    switch (numCas) {

      case 812: this.OperacionCs812(); break;

    }
  }
  OperacionCs812() {
    this.model.doc.cuerpo.cs_id_812 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_812, true);
    const cas812 = this.model.doc.cuerpo.cs_id_812
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas812, "0")) {
      this.dNotificacionServicio.mostrarDialogoInformacion("El valor de su patrimonio líquido de la declaración de renta del año anterior no puede ser menor a cero");
      this.model.doc.cuerpo.cs_id_812="0";
      return
    }
  }

   ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {
      this.model.doc.cuerpo.cs_id_813 = val;

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    this.model.doc.cuerpo.cs_id_812 = "0";
    this.model.doc.cuerpo.cs_id_813 = null;
    this.model.doc.cuerpo.cs_id_814 = "0";
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  protected validateShowSave(){
    if (this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == VAL_INDICADOR_COMPLETO){this.showSave=true;}
  }
  
  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/descuentos/descuentos-sancion-extemporanea-modal/descuentos-sancion-extemporanea-modal.component.ts